async function runAndWaitForApproval(documentServices, appData, token, action) {
  return await documentServices.transactions.runAndWaitForApproval(action, {
    appDefinitionId: appData.appDefinitionId,
  })
}

export default {
  runAndWaitForApproval,
}
